/**
 * The name, in two colours so it reads as the two words it is made of: ANI in
 * the Sakura line's pink, METRO in the network's amber. アニメ and メトロ share
 * their メ the way "anime" and "metro" share "me", and both scripts give the
 * shared syllable to METRO, so the katakana splits where the Latin does.
 *
 * The colours are `--ani` and `--metro` (styles/brand.css), which surfaces that
 * are not dark, like the paper tickets, darken for contrast.
 */
export function Wordmark({ kana = false }: { kana?: boolean }) {
  return (
    <span className="wm">
      <span className="wm-ani">{kana ? 'アニ' : 'ANI'}</span>
      <span className="wm-metro">{kana ? 'メトロ' : 'METRO'}</span>
    </span>
  );
}
